import React from 'react'

/** @param {import('./Image').ImageProps} props */
export default function Image(props) {
    const {ready, lazy, ...imageAttrs} = props

    return ready ? (
        <img loading={lazy ? 'lazy' : 'eager'} {...imageAttrs} />
    ) : (
        <span className="rasterizing-message-small">
            <i className="fas fa-wrench" />
            Конвертируется...
        </span>
    )
}
